<div class="pt-xs px-bl-2 pb-bl-2">
  <cla-vehicles-table></cla-vehicles-table>
</div>
